import moment from "moment";
export const timestamp = (value, format = "DD/MM/YYYY") => {
  return moment(value).format(format);
};
